import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, Message } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';

@Component({
  selector: 'app-payment-terms',
  templateUrl: './payment-terms.component.html',
  styleUrls: ['./payment-terms.component.scss']
})
export class PaymentTermsComponent implements OnInit {
  date: any;
  submitButton: string = 'Submit'
  paymentTermsTable: any = [];
  myDate: any;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(private _apiService: ApiServiceService, private _utility: AppUtility , private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.getAllTableData();
  }

  breadcrumb = [
    {
      title: 'Payment Terms List',
      subTitle: 'Dashboard'
    }
  ]

  paymentTermsProcessForm = new FormGroup({
    paymentTermsName: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required])
  })

  paymentTermsProcessFormSubmit(paymentTerms: FormGroupDirective) {
    console.log(this.paymentTermsProcessForm.value);
    if (this.paymentTermsProcessForm.valid) {
      this._utility.loader(true);
      let object = this.paymentTermsProcessForm.value;
      if (this.submitButton == 'Submit') {
        this._apiService.addpaymentTerms(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.paymentTermsProcessForm.reset();
            // ;          
            Object.keys(this.paymentTermsProcessForm.controls).forEach(key => {
              this.paymentTermsProcessForm.controls[key].setErrors(null)
            });
            paymentTerms.resetForm();
            this.getAllTableData();
          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }

        })
      }
      else {
        object['paymentTermsId'] = this.editItemId;
        console.log(object);
        this._apiService.editpaymentTerms(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.paymentTermsProcessForm.reset();
            Object.keys(this.paymentTermsProcessForm.controls).forEach(key => {
              this.paymentTermsProcessForm.controls[key].setErrors(null)
            });
            paymentTerms.resetForm();
            this.submitButton = 'Submit'
            this.getAllTableData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }

  editItemId: any;
  EditItem(customer: any) {
    if (customer.paymentTermsId) {
      Object.keys(this.paymentTermsProcessForm.controls).forEach(key => {
        this.paymentTermsProcessForm.controls[key].setValue(customer[key]);
      });
      this.submitButton = 'Update'
      this.editItemId = customer.paymentTermsId;
    }
  }

  getAllTableData() {
    this._utility.loader(true);
    this._apiService.getpaymentTerms()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          this.paymentTermsTable = res.returnValue;
        }
        else {
          this.paymentTermsTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.paymentTermsTable = [];
      })
  }

  confirm1(costBreakupId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete Payment Terms Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(costBreakupId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(itemId: any) {
    this._utility.loader(true);
    this._apiService.deletemanufacture(itemId)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getAllTableData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getAllTableData();
      }

    })
  }
}
